import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import { DataIntegrityError, DatabaseError } from "../auth/errors";

import { ConversationId, MacroId, SupportTicketId } from "../ids/definitions";
import { SupportTicketSnoozeOptions } from "../models/shopper-ai/conversation/support-ticket";

export const Macro = Schema.Struct({
  id: MacroId,
  name: Schema.String,
  content: Schema.String,
  htmlContent: Schema.String,
  tagsToAdd: Schema.NullOr(Schema.Array(Schema.String)),
  statusToSet: Schema.NullOr(Schema.String),
  snoozeDuration: Schema.NullOr(SupportTicketSnoozeOptions),
  emailSubjectToSet: Schema.NullOr(Schema.String),
  shouldAddNote: Schema.Boolean,
  noteToAddContent: Schema.NullOr(Schema.String),
  noteToAddHtmlContent: Schema.NullOr(Schema.String),
  noteToAddUsersMentioned: Schema.NullOr(Schema.Array(Schema.String)),
  shouldForwardMessage: Schema.Boolean,
  messageToForwardExtraContent: Schema.NullOr(Schema.String),
  messageToForwardEmailAddress: Schema.NullOr(Schema.String),
});
export type Macro = typeof Macro.Type;

const GetMacrosResponse = Schema.Struct({ macros: Schema.Array(Macro) });

const ReplaceMacroVariablesPayloadBase = {
  content: Schema.String,
  timezone: Schema.optional(Schema.String),
};

export const ReplaceMacroVariablesPayload = Schema.Union(
  Schema.Struct({
    ...ReplaceMacroVariablesPayloadBase,
    conversationId: ConversationId,
  }),
  Schema.Struct({
    ...ReplaceMacroVariablesPayloadBase,
    supportTicketId: SupportTicketId,
  }),
);
export type ReplaceMacroVariablesPayload =
  typeof ReplaceMacroVariablesPayload.Type;

const ReplaceMacroVariablesResponse = Schema.Struct({
  message: Schema.String,
  valuesExistForAllVariables: Schema.Boolean,
});

export const MacroGroup = HttpApiGroup.make("macro")
  .add(
    endpoint.merchant
      .get("getMacros", "/macros")

      .addSuccess(GetMacrosResponse)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("replaceMacroVariables", "/macros/replace-variables")

      .setPayload(ReplaceMacroVariablesPayload)
      .addSuccess(ReplaceMacroVariablesResponse)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
